// extracted by mini-css-extract-plugin
export default {"tabs":"TopCourseTabs_tabs__kr22x","tabItem":"TopCourseTabs_tabItem__MiJ96","active":"TopCourseTabs_active__4aZM7","tabItemInner":"TopCourseTabs_tabItemInner__D2VNW"};